import { ReactNode } from 'react';
import { Image, ImageName } from '@acme/assets';
import { twMerge } from 'tailwind-merge';
import { Button } from 'flowbite-react';

export type SampleProps = {
  children?: ReactNode;
  imageName?: ImageName;
  button?: {
    title: string;
    onClick: () => void;
  } | null;
  title?: string | ReactNode;
  message?: ReactNode;
  className?: string;
};

export const Sample = (props: SampleProps) => {
  return (
    <div
      className={twMerge(
        'flex-1 mx-auto flex justify-center items-center gap-6 flex-col',
        props.className
      )}
    >
      {props.children || (
        <>
          {props.imageName && (
            <Image name={props.imageName} alt={props.imageName} />
          )}

          <div className="text-center">
            {props.title && <span className="font-medium">{props.title}</span>}
            {props.message && (
              <div className="text-gray-500">{props.message}</div>
            )}
          </div>

          {Boolean(props.button) && (
            <Button
              color="primary"
              onClick={props.button?.onClick}
              className={twMerge('h-10')}
            >
              {props.button?.title}
            </Button>
          )}
        </>
      )}
    </div>
  );
};
